export default __webpack_public_path__ + "static/media/close-training.7480787a.svg";